import BlogList from "../components/blog/blogList.jsx";
import HeroSection from "../components/blog/hero.jsx";
import AgentCard from "../components/home/AgentCard.jsx";
import Navbar from "../components/Navbar.jsx";
import Footer from "../components/Footer.jsx";
const BlogsPage = () => {
  return (
    <div>
      <Navbar/>
      <HeroSection/>
      <BlogList/>
      <AgentCard/>
      <Footer/>
    </div>
  );
};

export default BlogsPage;
